import React, { Component } from 'react';
import style from './row.section.less';
import { compareObjects } from '../../common/utils.jsx';


export default class RowSection extends Component {
    shouldComponentUpdate(nextProps) {
        let isDifferentCondition;
        const { condition, fieldValues } = this.props;
        const { condition: nextCondition, fieldValues: nextFieldValues } = nextProps;
        if ('function' === typeof condition) {
            isDifferentCondition = condition(fieldValues) !== nextCondition(nextFieldValues);
        }
        const isDifferentFieldValues = compareObjects(fieldValues, nextFieldValues);
        return isDifferentCondition || isDifferentFieldValues;
    }
    render() {
        const { condition, fieldValues } = this.props;
        let isOpen = true;
        if ('function' === typeof condition) { isOpen = condition(fieldValues); }
        if (!isOpen) { return null; }
        return (
            <div className={style.wrapper}>
                <div className={style.container}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}
